Ctrl.$inject = ['$scope', '$state', 'PortalApi', "Authentication", "$rootScope", "Localization"];

function Ctrl($scope, $state, PortalApi, Authentication, $rootScope, Localization) {

    $scope.refactLog = false;       // flags for acitve or disabled input
    $scope.refactMail = false;
    $scope.refactPhone = false;

    $scope.preLoader = false;

    var user = Authentication.getUser();    // take user info
    // console.log(user);

    $scope.changesForm = {
        name: user.name,
        email: user.email
    };

    if($rootScope.useFrame && $state.current.data.iframe == false){
        document.body.classList.remove('bodyContainer');
        $state.go('pages.error404');
        $rootScope.useFrame = false;
    }

    $scope.changeDisabled = function (elemClass) {
        switch(elemClass){
            case 'name':{
                $scope.refactLog = !$scope.refactLog;
                break;
            }
            case 'changeMob':{
                $scope.refactPhone = !$scope.refactPhone;
                break;
            }
            case'email':{
                $scope.refactMail = !$scope.refactMail;
                break;
            }
        }
    };

    $scope.changeUserData = function (obj,type) {
        $scope.preLoader = true;

        PortalApi.changeInfo(obj).then(
            function(response){
                changeUserInfo(obj, type);
            },
            function (response) {
                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.CHANGE_LOGIN', 5, true);
                $scope.preLoader = false;
            }
        );
    };

    function changeUserInfo(data, type) {
        $scope.changeDisabled(type);
        Authentication.user[type] = data[type];
        localStorage.setItem('user', JSON.stringify(Authentication.user));
        $scope.preLoader = false;
    }

    $scope.doChanges = function(elClass){
        $scope.changeDisabled(elClass);
    };

    $scope.close = function (elClass) {
        $scope.changesForm[elClass] = Authentication.user[elClass];
        $scope.changeDisabled(elClass);

        // if($scope.changesForm.name ){
        //     $scope.changesForm.name = "";
        // }
        // if($scope.changesForm.email){
        //     $scope.changesForm.email = "";
        // }
    }


}

module.exports = Ctrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/userSettings/controllers/userSettings.controller.js
 ** module id = 298
 ** module chunks = 1
 **/